<template>
  <div class="position-relative">
    <b-button type="button" class="clear-cart fw-bold" @click="removeAllModal = true">
      Clear Cart
    </b-button>
    <div class="remove-all-modal" v-show="removeAllModal && source != 'navbar'">
      <label for="remove-all-items">Remove all items?</label>
      <ul>
        <li @click="$emit('confirmRemoveAll')">Yes</li>
        <li @click="removeAllModal = false">No</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["webDesign", "source"],
  data() {
    return {
      removeAllModal: false
    }
  }
}
</script>

<style lang="scss" scoped>
.clear-cart {
  padding: 3px !important;
  background-color: transparent !important;
  border-radius: 31px !important;
  min-width: 85px;
  font-size: 12px;
  border-color: #2F3941;
  color: #2F3941;
  &:focus,
  &:active,
  &:hover {
    color: #2F3941;
  }
}
.remove-all-modal {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  width: 180px;
  text-align: center;
  padding: 15px 20px;
  z-index: 2;
  position: absolute;
  right: 10px;
  bottom: -120px;

  label {
    text-align: center;
    font-style: normal;
    font-size: 16px;
    color: #2f3941;
  }

  ul {
    margin: 10px 0px;
    list-style: none;
    padding: 0px;

    li {
      width: 50%;
      display: inline-block;
      font-style: normal;
      font-size: 18px;
      cursor: pointer;

      &:last-child {
        color: $orange;
      }
    }
  }
}
</style>
